import React, { useState, useEffect } from 'react';
import './CustomRadios.scss';
import { Image } from 'react-bootstrap';
import CheckedRadio from '../../assets/images/checked_radio.svg';
import UncheckedRadio from '../../assets/images/unchecked_radio.svg';
import CustomTips from './CustomTips';
function CustomRadios(props) {
  const onChange = props.onChange;
  const options = props.options;
  const onFocus = props.onFocus||(()=>{})
  const [selected, setSelected] = useState();
  const disabled = props.disabled || false;

  useEffect(() => {
    setSelected(props.default);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.default]);

  return <div className={`radio-area d-flex ${props.className || ''}`}>
    {options.map((item, index) => {

      return (
        <div className='one-radio-area'>
          <div
            className={`radio-button-container ${item.customClass || ''}`}
            key={`radios-${index}-div-${item.value}`}
            onClick={() => {
              if (disabled) {
                return;
              }

              if (item.value === selected) {
                return;
              }
              console.log('34-2', item.label, selected, item.value)
              setSelected(item.value);
              onChange(item.value);
              onFocus()
            }}
          >
            <Image
              src={selected === item.value ? CheckedRadio : UncheckedRadio}
              className="radio-button"
            />
            {item?.popoverTips ?
              <CustomTips
                detail={item.popoverTips}
              >
                <label className={`radio-button-label ${props.labelClass || ''}`}>
                  {item.label}
                </label>
            </CustomTips>
            :
              <div>
                <label className={`radio-button-label ${props.labelClass || ''}`}>
                  {item.label}
                </label>
                {item?.innerTips ? <label className='radio-button-label tips-message'>{item.innerTips}</label> : null}
              </div>
            }
          </div>
          {item?.tips ? <label className='tips-message'>{item.tips}</label> : null}
        </div>

      );
    })}
  </div>
}

export default CustomRadios;
